module.exports = __webpack_public_path__ + "static/supplement_facts_mobile-fb9ad941dc8e7ff1996b4840c56492bf.png";